const allowedRoutes = [
    'Login',
    'Page404',
    'Register',
    'Page500',
    'example',
]

export default allowedRoutes